"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tile = void 0;
var common_1 = require("@timeflies/common");
var layer_1 = require("./layer");
var Tile;
(function (Tile) {
    Tile.getTilePositionFromIndex = function (index, _a) {
        var width = _a.width;
        var y = Math.floor(index / width);
        var x = (index % width);
        return common_1.createPosition(x, y);
    };
    Tile.getTilePositionFromTileset = function (tileId, _a) {
        var columns = _a.columns;
        var y = Math.floor(tileId / columns);
        var x = (tileId % columns);
        return common_1.createPosition(x, y);
    };
    Tile.getWorldPositionFromTilePosition = function (tilePosition, _a, layerOffset) {
        var _b, _c;
        var tilewidth = _a.tilewidth, tileheight = _a.tileheight;
        var offsetX = (_b = layerOffset === null || layerOffset === void 0 ? void 0 : layerOffset.offsetx) !== null && _b !== void 0 ? _b : 0;
        var offsetY = (_c = layerOffset === null || layerOffset === void 0 ? void 0 : layerOffset.offsety) !== null && _c !== void 0 ? _c : 0;
        return common_1.createPosition(tilePosition.x * tilewidth + offsetX, tilePosition.y * tileheight + offsetY);
    };
    Tile.getTilesetFromTileId = function (tileId, _a) {
        var tilesets = _a.tilesets;
        return tilesets.find(function (t) { return t.firstgid <= tileId && t.firstgid + t.tilecount - 1 >= tileId; });
    };
    Tile.getTileAnimation = function (tileId, _a) {
        var _b;
        var _c = _a.tiles, tiles = _c === void 0 ? [] : _c;
        var tileAnimation = (_b = tiles.find(function (tile) { return tile.id === tileId - 1; })) === null || _b === void 0 ? void 0 : _b.animation;
        if (!(tileAnimation === null || tileAnimation === void 0 ? void 0 : tileAnimation.length)) {
            return null;
        }
        return tileAnimation.map(function (_a) {
            var tileid = _a.tileid, duration = _a.duration;
            return ({
                tileid: tileid + 1,
                duration: duration
            });
        });
    };
    var getTileIdFromPosition = function (_a, _b) {
        var _c;
        var data = _a.data, width = _a.width;
        var x = _b.x, y = _b.y;
        var index = x + y * width;
        return (_c = data[index]) !== null && _c !== void 0 ? _c : 0;
    };
    var hasTileFromLayer = function (layer, position) {
        return getTileIdFromPosition(layer, position) !== 0;
    };
    Tile.getTileTypeFromPosition = function (position, tiledMap) {
        var obstaclesLayer = layer_1.Layer.getTilelayer('obstacles', tiledMap);
        if (hasTileFromLayer(obstaclesLayer, position)) {
            return 'obstacle';
        }
        return 'default';
    };
})(Tile = exports.Tile || (exports.Tile = {}));
